import React, { useRef, useEffect } from 'react';

// Size xl / lg / sm
const Modal = ({
  id,
  title,
  children,
  onConfirm,
  cancelText = 'Close',
  confirmText = 'Confirm',
  showFooter = true,
  loading = false,
  size = '',
  resetOnClose = true, // 👈 new option to reset forms
  loadingText = 'Loading...',
}) => {
  const modalRef = useRef(null);
  useEffect(() => {
    const el = modalRef.current;
    if (!el) return;

    const onShown = () => {
      const $ = window.$;
      if ($?.fn?.niceSelect) {
        $(el)
          .find('select')
          .each(function () {
            const $sel = $(this);
            try {
              $sel.niceSelect('destroy');
            } catch {}
            $sel.next('.nice-select').remove();
            $sel.show().niceSelect();
          });
      }
    };

    const onHidden = () => {
      const $ = window.$;
      if ($?.fn?.niceSelect) {
        $(el)
          .find('select')
          .each(function () {
            const $sel = $(this);
            try {
              $sel.niceSelect('destroy');
            } catch {}
            $sel.next('.nice-select').remove();
            $sel.show();
          });
      }
    };

    el.addEventListener('shown.bs.modal', onShown);
    el.addEventListener('hidden.bs.modal', onHidden);
    return () => {
      el.removeEventListener('shown.bs.modal', onShown);
      el.removeEventListener('hidden.bs.modal', onHidden);
    };
  }, []);
  const handleConfirm = async () => {
    try {
      if (onConfirm) {
        await onConfirm(); // run parent confirm (e.g. submit, Firestore write)
      }

      // ✅ Reset all forms inside modal
      if (resetOnClose && modalRef.current) {
        const forms = modalRef.current.querySelectorAll('form');
        forms.forEach((form) => form.reset());
      }

      // ✅ Close modal programmatically
      const modalElement = document.getElementById(id);
      if (modalElement) {
        const modalInstance =
          window.bootstrap?.Modal.getInstance(modalElement) ||
          new window.bootstrap.Modal(modalElement);
        modalInstance.hide();
      }
    } catch (err) {
      console.error('Modal confirm error:', err);
    }
  };

  return (
    <div
      className='modal fade'
      id={id}
      tabIndex='-1'
      aria-labelledby={`${id}Label`}
      aria-hidden='true'
      ref={modalRef}
    >
      <div
        className={
          size === 'medium' ? 'modal-dialog' : `modal-dialog modal-${size}`
        }
        role='document'
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id={`${id}Label`}>
              {title}
            </h5>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
            ></button>
          </div>

          <div className='modal-body'>{children}</div>

          {showFooter && (
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-secondary'
                data-bs-dismiss='modal'
              >
                {cancelText}
              </button>
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleConfirm}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className='bx bx-loader bx-spin font-size-16 align-middle me-2'></i>
                    {loadingText}
                  </>
                ) : (
                  confirmText
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
